/**
 * Vue2 observe visibility plugin
 */
import 'intersection-observer'; // polyfill
import { ObserveVisibility } from 'vue-observe-visibility';

export const plugin = {
    name: 'observe-visibility',

    install (Vue) {
        Vue.directive('observe-visibility', ObserveVisibility);
    }
};

export default plugin;
